import axios from "axios";
import EndPoints from "../endPoints";
import Utils from "../alert";

export const getToken = () =>
  localStorage.getItem("accessToken")
    ? localStorage.getItem("accessToken")
    : null;

const getAuthorizationHeader = () => getToken();

export const getUsertypeFromLS = () => {
  return localStorage.getItem("userType");
};

export const getUserIdFromLS = () => {
  return localStorage.getItem("id");
};

/**
 * setup axios instance
 */
const $axios = axios.create({
  timeout: 100000,
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Authorization: getAuthorizationHeader(),
  },
});

$axios.defaults.headers.Authorization = getAuthorizationHeader();

$axios.interceptors.request.use(
  (config) => {
    const user = getAuthorizationHeader();
    if (user) {
      config.headers["Authorization"] = `${user}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

$axios.interceptors.response.use(
  (config) => {
    let path = config?.config?.url;
    if (config.status === 200 && path.includes("store/?order=")) {
      // ;
      localStorage.removeItem("royaltyStatus");
    }
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    const path = error.response?.data?.path;
    if (error.response?.data?.statusCode === 1102) {
      localStorage.setItem("royaltyStatus", "Unpaid");
    }
    if (
      error.response &&
      error.response.status === 401
    ) {
      localStorage.clear();
      sessionStorage.clear();
      setTimeout(() => {
        window.location.href = "/";
        Utils.showAlert(2, "Session expired. Please login again.");
      }, 1500);
    }
    return Promise.reject(error);

    return Promise.reject(error);
  }
);

export const api_header_code = {
  alreadyEnabled2fa: 2003,
};

export const api_error_code = {
  unauthorized: 401,
  accessDenied: 430,
  sessionExpired: 440,
  validationError: 400,
  emailNotVerified: 403,
};

export const api_success_code = {
  postSuccess: 201,
  success: 200,
};

export const API_URL = process.env.REACT_APP_API_URL;
export const Bucket = process.env.REACT_APP_BUCKET_NAME;
export const BASE_S3_URL = process.env.REACT_APP_S3_BASE_PATH;

export const imgSvToken = process.env.REACT_APP_IMG_SV_TOKEN;

export { $axios };
